import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import { usersSelector } from '@/state/user/slices/index.slices'

type Props = {
  activeStep: number
}

const TwoFactorActiveTwoComponent = ({ activeStep }: Props) => {
  const { t } = useTranslation()

  const { secretCode } = useSelector(usersSelector)

  const secretKey = secretCode !== '' ? secretCode.split('=')[1] : ''

  return (
    <>
      <Box mt={2}>
        <Typography className="fontWeight-500" paragraph>
          {t('twoFactor.scanBarcode')}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.scanBarcodeStepOne'),
        }}
      />
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.scanBarcodeStepTwo'),
        }}
      />
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.scanBarcodeStepThree'),
        }}
      />
      <Box
        border="1px solid"
        borderRadius="4px"
        padding={2.5}
        my={2}
        display="flex"
        justifyContent="center"
        flexDirection="column"
      >
        {activeStep === 2 && secretKey !== '' && (
          <>
            <Typography
              variant="body2"
              className="fontWeight-700"
              align="center"
            >
              {secretKey !== null &&
                secretKey.split(/(?<=^(?:.{4})+)(?!$)/).join(' ')}
            </Typography>
            <Box mt={2}>
              <Typography component="p" align="center">
                {t('twoFactor.noTakeSpaces')}
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.scanBarcodeStepFour'),
        }}
      />
    </>
  )
}

export default TwoFactorActiveTwoComponent
